<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div>
    <headlink></headlink>
    <div class="container ui-flex ui-flex-pack-center">
      <div class="left-container" >
        <div class="left-logo" style="padding-bottom: 20px;" >
          <img src="/static/img/phone.png" style="margin-top: 20px;margin-bottom: 20px;" />
          <span style="    color: #005ad5;
    font-weight: bold;
    font-size: 22px;" >{{mobile}}</span>
        </div>
        <!--<div v-on:click="go('/userManage')"  class="left-column ui-flex  ui-flex-align-center ui-flex-pack-center">
              <div><img src="/static/img/icon1.png" /> </div><div class="column-table" ><span>消息推送</span></div><i class="ui-icon-next"></i>
          </div>-->
        <div v-on:click="go('/userManage')"  class="left-column ui-flex  ui-flex-align-center ui-flex-pack-center">
          <div><img src="/static/img/icon2.png" /> </div><div class="column-table" ><span>修改密码</span></div><i class="ui-icon-next"></i>
        </div>
      </div>
      <div class="right-container ui-center 	" >
        <div class="input-container padding-top-100" >
          <div>
            <input v-model="oldpwd" type="password" class="input-big input" placeholder="请输入旧密码"/>
          </div>
          <div>
            <input v-model="newpwd" type="password" class="input-big input" placeholder="请输入新密码"/>
          </div>
          <div>
            <input v-model="confirmPwd" type="password" class="input-big input" placeholder="请确认新密码"/>
          </div>
          <div>
            <span class="error" >{{error}}</span>
          </div>
          <button class="button-sure" v-on:click="updatePwd()">
            确认
          </button>
        </div>
      </div>
      <div class="alert" v-show="alertFlag"  >
        <div class="dialog" >
          <div style="text-align: center;color:red;" >{{msg}}</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import headlink from '@/components/common/headlink'

  export default {
    name: 'info',
    data () {
      return {
        oldpwd:"",
        newpwd:"",
        confirmPwd:"",
        error:"",
        alertFlag:false,
        msg:"",
        mobile:""
      }
    },
    methods:{

      go:function(url){
        this.$router.push(url);
      },
      updatePwd:function(){
        var self = this;
        if(this.oldpwd==''){
          self.msg = "请输入旧密码";
          self.alertFlag = true;
          window.setTimeout(function(){
            self.alertFlag = false;
          },1000);
          return ;
        }
        if(this.oldpwd.length < 6){
          self.msg = "请输入旧密码少于6位";
          self.alertFlag = true;
          window.setTimeout(function(){
            self.alertFlag = false;
          },1000);
          return ;
        }
        if(this.newpwd==''){
          self.msg = "请输入新密码";
          self.alertFlag = true;
          window.setTimeout(function(){
            self.alertFlag = false;
          },1000);
          return ;
        }
        if(this.newpwd.length < 6){
          self.msg = "请输入新密码少于6位";
          self.alertFlag = true;
          window.setTimeout(function(){
            self.alertFlag = false;
          },1000);
          return ;
        }
        if(this.confirmPwd==''){
          self.msg = "请确认新密码";
          self.alertFlag = true;
          window.setTimeout(function(){
            self.alertFlag = false;
          },1000);
          return ;
        }
        if(this.confirmPwd.length < 6){
          self.msg = "确认新密码少于6位";
          self.alertFlag = true;
          window.setTimeout(function(){
            self.alertFlag = false;
          },1000);
          return ;
        }
        if(this.newpwd!=this.confirmPwd){
          self.msg = "两次输入的密码不一致，请重新输入";
          self.alertFlag = true;
          window.setTimeout(function(){
            self.alertFlag = false;
          },1000);
          return ;
        }
        const history = window.sessionStorage;
        var uid = history.getItem("user");
        this.$http.post('/ZYun/HttpService.do', {
          "serviceCode":"1006",
          "uId":uid,
          "oldPwd":this.oldpwd,
          "newPwd":this.newpwd
        })
          .then((response) => {
            self.msg = response.data.respMsg;
            self.alertFlag = true;
            self.error = "";
            self.oldpwd = "";
            self.newpwd = "";
            self.confirmPwd = "";
            window.setTimeout(function(){
              self.alertFlag = false;
            },1000);
          })
          .catch((response) =>{
            console.log(response);
          });
      }
    }, mounted: function () {
      const history = window.sessionStorage;
      var mobile = history.getItem("mobile");
      this.mobile = mobile;
    },
    components: {
      headlink:headlink
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../static/css/index.css" >
</style>



// WEBPACK FOOTER //
// src/components/info/info.vue